"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearFilter = void 0;
const types_1 = require("./types");
const clearFilter = (filterToClean, doNotClone = false) => {
    let clonedFilter = doNotClone ? filterToClean : JSON.parse(JSON.stringify(filterToClean));
    if (Array.isArray(clonedFilter)) {
        clonedFilter = clonedFilter
            .map(filter => {
            if ((0, types_1.isAndFilter)(filter) || (0, types_1.isOrFilter)(filter)) {
                return (0, exports.clearFilter)(filter, true);
            }
            if (!(0, types_1.isUnaryFilter)(filter) && filter.values.length > 0) {
                return Object.assign(Object.assign({}, filter), { values: filter.values.filter(Boolean) });
            }
            return filter;
        })
            .filter(filter => {
            if ((0, types_1.isAndFilter)(filter) || (0, types_1.isOrFilter)(filter)) {
                return true;
            }
            if (!filter.member) {
                return false;
            }
            if (!(0, types_1.isUnaryFilter)(filter) && filter.values.length === 0) {
                return false;
            }
            return true;
        });
    }
    else if ((0, types_1.isAndFilter)(clonedFilter)) {
        clonedFilter.and = (0, exports.clearFilter)(clonedFilter.and, true);
    }
    else if ((0, types_1.isOrFilter)(clonedFilter)) {
        clonedFilter.or = (0, exports.clearFilter)(clonedFilter.or, true);
    }
    return clonedFilter;
};
exports.clearFilter = clearFilter;
//# sourceMappingURL=clearFilter.js.map